module.exports = __webpack_public_path__ + "static/media/F8A324CC-971C-4811-B259-D5B324B74DCA.45ae8980.jpeg";